import { handleJsonPostError, jsonPostV2 } from "./apiUtils";
import _ from "lodash";

export const VIDEO_LOOKUP_QUEUE = "VIDEO_LOOKUP_QUEUE";
export const RECEIVE_VIDEO_LOOKUP_DATA = "RECEIVE_VIDEO_LOOKUP_DATA";

let pendingVideoToRequest = {};

const receiveVideoTimestampLookupResult = (videoLookupData) => {
    return {
        type: RECEIVE_VIDEO_LOOKUP_DATA,
        videoLookupData,
    };
};

export function getVideoFromSessionTimestamp(session_id, timestamp) {
    return (dispatch, getState) => {
        return new Promise((resolve, reject) => {
            const sessionTimestampLookupCache = getState().timestampVideoLookup;

            if (sessionTimestampLookupCache.hasOwnProperty(session_id)) {
                const allSessionData = sessionTimestampLookupCache[session_id];
                const timestampMatchingData = getNearestTimestampData(timestamp, allSessionData);

                if (!_.isEmpty(timestampMatchingData)) {
                    resolve(timestampMatchingData);
                    return;
                }
            }

            //General flow here:
            //Add the session ID & promise to the list of sessions to request
            if (!pendingVideoToRequest.hasOwnProperty(session_id)) {
                pendingVideoToRequest[session_id] = [{ resolve, reject, timestamp }];
            } else {
                pendingVideoToRequest[session_id].push({ resolve, reject, timestamp });
            }

            //Call the method that checks and requests the session data
            dispatch(sessionVideoLookupDispatcher());
        }).catch((e) => {});
    };
}

const getNearestTimestampData = (requestedTimestamp, sessionData) => {
    let matchingData = {};
    Object.keys(sessionData).forEach((timestamp) => {
        if (requestedTimestamp - 1000 <= timestamp && timestamp <= requestedTimestamp + 1000) {
            matchingData = {
                ...matchingData,
                ...sessionData[timestamp],
            };
        }
    });

    return matchingData;
};

function sessionVideoLookupDispatcher() {
    return {
        queue: VIDEO_LOOKUP_QUEUE,
        callback: (next, dispatch, getState) => {
            const pendingVideoAtTimeOfRequest = _.clone(pendingVideoToRequest);

            const session_ids = Object.keys(pendingVideoAtTimeOfRequest).slice(0, 100);

            const lookupPayload = session_ids.flatMap((sessionID) => {
                const requestData = pendingVideoAtTimeOfRequest[sessionID];

                return _.uniqBy(requestData, "timestamp").map((data) => {
                    return { session_id: sessionID, timestamp: data.timestamp };
                });
            });

            // pendingVideoToRequest = {};
            session_ids.forEach((sessionID) => {
                delete pendingVideoToRequest[sessionID];
            });

            if (session_ids.length === 0) {
                //Nothing to do
                setTimeout(() => next(), 0);
                return;
            }

            let postBody = {
                action: "batch_get_session_images",
                timestamp_items: lookupPayload,
            };

            let url = "/sessions";

            jsonPostV2(url, getState(), postBody, dispatch)
                .then(({ images }) => {
                    if (images) {
                        console.log("Images list retrieved, contains " + images.length + " sessions.");

                        dispatch(receiveVideoTimestampLookupResult(images));
                    }
                })
                .catch((error) => {
                    handleJsonPostError("Unable to retrieve video lookup list", "An error occurred while fetching the session list", error);
                })
                .then(() => {
                    const cachedSessionVideo = getState().timestampVideoLookup;
                    session_ids.forEach((session_id) => {
                        const promises = pendingVideoAtTimeOfRequest[session_id];
                        if (cachedSessionVideo.hasOwnProperty(session_id)) {
                            const session_data = cachedSessionVideo[session_id];
                            for (let i = 0; i < promises.length; i++) {
                                promises[i].resolve(getNearestTimestampData(promises[i].timestamp, session_data));
                            }
                        } else {
                            for (let i = 0; i < promises.length; i++) {
                                promises[i].reject();
                            }
                        }
                    });
                })
                .finally(() => {
                    //After the request is complete, schedule another in case more session data is pending
                    next();
                    dispatch(sessionVideoLookupDispatcher());
                    console.log("Video lookup request complete.");
                });
        },
    };
}
